import React from 'react';
import PropTypes from 'prop-types';
import Error from '../../containers/Error';
import Notification from '../../containers/Notification';
import InputWithLabel from '../base/InputWithLabel/InputWithLabel';
import SaveButton from '../Buttons/SaveButton';
import DismissButton from '../Buttons/DismissButton';
import Select from '../base/SelectWithLabel/SelectWithLabel';
import textTranslates from './translate.json';

const WaybillDataModalBody = (props) => {
    
    function onFormSubmit(e) {
        e.preventDefault();
        props.onFormSubmit(props.waybillData);
    }

    return(
        <div className="col-xs-12">
            <Error />
            <Notification />
            <form
                className="col-xs-12"
                onSubmit={onFormSubmit}>
                <div className="col-xs-12">
                    <InputWithLabel
                        className="col-xs-12 col-sm-6"
                        id="waybill-number-new"
                        label={textTranslates.waybillNumberNewNumberInputLabel}
                        onChange={props.onWaybillNumberChange}
                        placeholder={textTranslates.waybillNumberNewNumberInputPlaceholder}
                        type="text"
                        value={props.waybillData.newNumber} />
                </div>
                <div className="col-xs-12">
                    <div className="col-xs-12 col-sm-6">
                        <Select
                            label="Przewoźnik"
                            id="waybill-courier-new"
                            onChange={props.onWaybillCourierChange}
                            values={props.couriers}
                            value={props.waybillData.waybillCourier.value} />
                    </div>
                </div>
                <div className="col-xs-12">
                    <SaveButton
                        type="submit"
                        disabled={props.isSaveBtnDisabled} />
                </div>
            </form>
            <DismissButton onClick={props.onDismissButtonClick} />
        </div>
    );
};

WaybillDataModalBody.propTypes = {
    onSaveButtonClick: PropTypes.func,
    onDismissButtonClick: PropTypes.func,
    onWaybillCourierChange: PropTypes.func,
    onWaybillNumberChange: PropTypes.func,
    waybillData: PropTypes.shape({
        newNumber: PropTypes.string,
        waybillCourier: PropTypes.object,
        canSave: PropTypes.bool
    }),
    actualWaybillNumber: PropTypes.string,
    onFormSubmit: PropTypes.func,
    couriers: PropTypes.array,
    isSaveBtnDisabled: PropTypes.bool
};

export default WaybillDataModalBody;


// WEBPACK FOOTER //
// ./src/components/WaybillData/WaybillDataModalBody.js